module.exports = __webpack_public_path__ + "static/media/bg.579e24e5.jpeg";